var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.banPolicy)?_c('ban-policy-form',{model:{value:(_vm.banPolicy),callback:function ($$v) {_vm.banPolicy=$$v},expression:"banPolicy"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }